import React from 'react';

import OnHoverTooltip from '../../../../../tables/shared/OnHoverTooltip';
import SpinLoader from '../../shared/SpinLoader';

const Stage = ({
    pipelineStage,
    highlighted,
    hasArrow,
    onClick,
    isLoading,
    stageContent,
    secondaryStageContent}) => {

    secondaryStageContent = secondaryStageContent ?? pipelineStage.name;

    return (
        <li className={`${highlighted ? 'highlighted' : ''}`} onClick={onClick}>
            <OnHoverTooltip isSlimmed delay={{ show: stageContent ? 250 : 50, hide: 50 }} tooltipPlace='bottom'>
                <div className={`stage-content`}>
                    {!stageContent || isLoading ? '\u00A0' : (stageContent === "0 dagar" ? "<1 dag" : stageContent)}

                    <SpinLoader {...{ isLoading }} />
                </div>
                <div style={{ textAlign: 'left' }}>
                    <div style={{ fontWeight: 500 }}>{secondaryStageContent}</div>
                </div>
            </OnHoverTooltip>
            {hasArrow && <span className={`stage-arrow ${highlighted ? 'highlighted' : ''}`} />}
        </li>
    );
};

export default Stage;
